import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Circle } from '@dbk/ui-svg';

import theme from '@dbk/ui-theme';

const ITEM_STROKE = 2;
const ITEM_Radius = 10;

class PortfolioChartLegendItem extends Component {
  static propTypes = {
    stroke: PropTypes.string,
    fill: PropTypes.string,
  };

  static defaultProps = {
    stroke: theme.palettePrimaryActive,
    fill: 'transparent',
  };

  render() {
    const { stroke, fill } = this.props;
    return (
      <Circle
        r={ITEM_Radius - 1 - ITEM_STROKE / 2}
        cx={ITEM_Radius}
        cy={ITEM_Radius}
        stroke={stroke}
        strokeWidth={ITEM_STROKE}
        fill={fill}
      />
    )
  }
}

export default PortfolioChartLegendItem;
